import React from 'react';
import { ReactComponent as AlgovexIcon } from '../assets/algovex-icon-48.svg';

export default function SignupPrompt({ message, onSignup, onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.6)', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--card)', borderRadius: 12, padding: 32,
        maxWidth: 400, width: '90%', textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        border: '1px solid var(--border)',
      }}>
        <AlgovexIcon style={{ width: 44, height: 44, borderRadius: 10, marginBottom: 8 }} />
        <h3 style={{ margin: '0 0 8px', color: 'var(--text)' }}>Create a Free Account</h3>
        <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.5, margin: '0 0 20px' }}>
          {message || 'Sign up to unlock all features — it only takes a few seconds.'}
        </p>
        <button onClick={onSignup} style={{
          width: '100%', padding: '10px 0', fontSize: 14, fontWeight: 700,
          background: 'var(--teal)', color: 'var(--bg)', border: 'none',
          borderRadius: 8, cursor: 'pointer', marginBottom: 10,
        }}>
          Sign Up Free
        </button>
        <button onClick={onClose} style={{
          width: '100%', padding: '8px 0', fontSize: 13,
          background: 'none', color: 'var(--muted)', border: '1px solid var(--border)',
          borderRadius: 8, cursor: 'pointer',
        }}>
          Maybe Later
        </button>
      </div>
    </div>
  );
}
